// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-helper{\n    font-size:0.75rem;\n    color: #f44336;\n    text-align: left;\n    margin: 5px 14px 0;\n}\n.image_upload_true{\n    border:1px solid red;\n    height:200px;\n    position:relative;\n    border-radius:5px;\n    margin-top:10px\n}\n.image_upload_false{\n    border:1px solid #ccc;\n    height:200px;\n    position:relative;\n    border-radius:5px;\n    margin-top:10px\n}\n.image_i{\n    display:none;\n}", ""]);
// Exports
module.exports = exports;
